import { useMemo } from 'react';

export function filterByNameOrGroup<T extends { name: string; group: string }>(
  items: T[],
  query: string,
): T[] {
  if (!query) return items;

  const q = query.trim().toLowerCase();
  const matchingGroups = new Set(
    items.filter((c) => c.group.toLowerCase().includes(q)).map((c) => c.group),
  );

  return items.filter(
    (c) => c.name.toLowerCase().includes(q) || matchingGroups.has(c.group),
  );
}

export function useFilterByNameOrGroup<
  T extends { name: string; group: string },
>(items: T[], query: string): T[] {
  return useMemo(() => filterByNameOrGroup(items, query), [items, query]);
}
